import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import {
    TokenContext,
    DialogContext,
    ProjectContext,
} from "../../Store";
import {makeStyles} from "@mui/styles";
import {connect} from "react-redux";

import http from "../../../shared/http-common";
import MaterialTable from "@material-table/core";
import BimProjectCreate from "./BimProjectCreate";
import {confirmWrapper} from "../../../shared/confirm";
import UserService from "../../../services/UserService";

import { header } from'../../../shared/headerStyle';
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import BimUserProjects from '../BimUserProjects/BimUserProjects';

const TOOLBAR_HEIGHT = 74;
const COLUMN_HEADER = 50;
const PAGINATION_HEIGHT = 52;
const TABS_HEIGHT = 60;
const PADDING = 0;

const useStyles = makeStyles({
    root: {
        textAlign: "left",
        fontFamily: "poppins",
    },
    lightButton: {
        float: "right",
        fontWeight: "bold",
    },
    darkButton: {
        float: "right",
        color: "#e5e5e5",
        fontWeight: "bold",
    },
    katalogView: {
        width: "100%",
        height: "100%",
        float: "left",
    },
    btListe: {
        width: "100%",
        maxHeight: "100vh",
        float: "left",
    },
    table: {
        minWidth: 700,
    },
});


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: '12px' }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function DataListView({ projectList, deleteProject, handleDeactivateClick, addNew, handleClickOnRow }) {
    const tableRef = useRef();
    const tableHeight = `calc(100vh - ${TOOLBAR_HEIGHT + COLUMN_HEADER + PAGINATION_HEIGHT + TABS_HEIGHT + PADDING}px)`;

    return (
        <MaterialTable
            tableRef={tableRef}
            title="Projekte"
            columns={[
                { title: 'Bezeichnung', field: 'name' },
                { title: 'Beschreibung', field: 'description'},
                { title: 'Profil', field: 'bimProfileName'},
                { title: 'deaktiviert', field: 'deactivated', lookup: { 0: 'nein', 1: 'ja' } },
            ]}
            data={projectList}
            options={{
                headerStyle: header,
                actionsColumnIndex: -1,
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100],
                exportButton: true,
                exportAllData: true,
                maxBodyHeight: tableHeight,
                minBodyHeight: tableHeight,
            }}
            actions={[
                {
                    icon: 'wysiwyg',
                    tooltip: 'Details',
                    onClick: (event, rowData) => handleClickOnRow(rowData)
                },
                {
                    icon: 'delete',
                    tooltip: 'löschen',
                    onClick: (event, rowData) => deleteProject(rowData),
                    disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                },
                rowData => ({
                    icon: rowData.deactivated ? 'taskalt' : 'cancel',
                    tooltip: rowData.deactivated ? 'Aktivieren' : 'Deaktivieren',
                    onClick: (event, rowData) => handleDeactivateClick(rowData),
                    disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                }),
                {
                    icon: 'add',
                    tooltip: 'Neues Projekt anlegen',
                    isFreeAction: true,
                    onClick: () => addNew(),
                    disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                }
            ]}
            onRowClick={(event, rowData) => handleClickOnRow(rowData)}
            localization={{
                pagination: {
                    labelDisplayedRows: '{from}-{to} von {count}',
                    labelRowsSelect: 'Zeilen',
                    labelRowsPerPage: 'Zeilen pro Seite'
                },
                toolbar: {
                    nRowsSelected: '{0} Zeile(n) ausgewählt',
                    searchTooltip: 'Suchen',
                    searchPlaceholder: 'Suchbegriff eingeben'
                },
                header: {
                    actions: ''
                },
                body: {
                    emptyDataSourceMessage: 'Keine Einträge gefunden',
                    filterRow: {
                        filterTooltip: 'Filter'
                    },
                    editRow: {
                        deleteText: 'Soll der Datensatz wirklich gelöscht werden?',
                        saveTooltip: 'Speichern',
                        cancelTooltip: 'Abbrechen'
                    }
                }
            }}
        />
    );
}

function BimProjects({theRealm}) {
    const [token] = useContext(TokenContext);
    const dialogCtx = useContext(DialogContext);
    const setBIMDialogOpen = dialogCtx.setBimOpen;
    const project = useContext(ProjectContext);
    const bimProjects = project.projects;
    const setBimProjects = project.setProjects;
    const BimProjectSelected = project.selected;
    const setBimProjectSelected = project.setSelected;
    const classes = useStyles();
    const [tabValue, setTabValue] = useState(0);

    const hasRole = UserService.hasRole(['MAP_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN']);

    const styles = {
        TabBorderStyle: {
            padding: "3px",
            borderRight: "1px solid black",
            borderTop: "1px solid black",
            borderLeft: "1px solid black",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
        }
    };

    const handleClickOnRow = useCallback((project) => {
        setBimProjectSelected(project);
        setBIMDialogOpen(true);
    }, [setBimProjectSelected, setBIMDialogOpen]);

    const reloadProjects = useCallback(async (project = null) => {
        try {
            const formData = new FormData();
            formData.append("realm", theRealm);
            const result = await http.post(`/project/listAll`, formData, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token
                }
            });
            setBimProjects(result.data);
            if (project) handleClickOnRow(project);
        } catch (e) {
            console.error("Fehler beim Laden der Projekte:", e);
        }
    }, [setBimProjects, theRealm, token, handleClickOnRow]);

    useEffect(() => {
        if (!UserService.isLoggedIn()) {
            UserService.doLogout();
        }
    }, []);

    useEffect(() => {
        if (!bimProjects) {
            reloadProjects();
        }
    }, [bimProjects, reloadProjects]);

    const handleDeactivateClick = (project) => {
        if (project.deactivated) {
            Project_activate(project);
        } else {
            Project_Deactivate(project);
        }
    };

    const Project_Delete = async (project) => {
        try {
            if (await confirmWrapper('Soll das Projekt wirklich gelöscht werden?')) {
                const formData = new FormData();
                formData.append("realm", theRealm);
                formData.append("projectId", project.id);
                formData.append("guid", project.guid);
                await http.post(`/project/delete`, formData, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + token
                    }
                });
                await reloadProjects();
                setBimProjectSelected([]);
            }
        } catch (e) {
            console.error("Fehler beim Löschen des Projekts:", e);
        }
    };

    const Project_Deactivate = async (project) => {
        try {
            const formData = new FormData();
            formData.append("realm", theRealm);
            formData.append("projectId", project.id);
            formData.append("guid", project.guid);
            await http.post(`/project/deactivate`, formData, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token
                }
            });
            await reloadProjects();
            setBimProjectSelected([]);
        } catch (e) {
            console.error("Fehler beim Deaktivieren des Projekts:", e);
        }
    };

    const Project_activate = async (project) => {
        try {
            const formData = new FormData();
            formData.append("realm", theRealm);
            formData.append("projectId", project.id);
            formData.append("guid", project.guid);
            await http.post(`/project/activate`, formData, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token
                }
            });
            await reloadProjects();
            setBimProjectSelected([]);
        } catch (e) {
            console.error("Fehler beim Aktivieren des Projekts:", e);
        }
    };

    const addNew = () => {
        setBimProjectSelected([]);
        setBIMDialogOpen(true);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <div>
            <div className={classes.katalogView}>
                <div className={classes.btListe}>
                    {hasRole ? (
                        <>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: '10px' }}>
                                <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example" sx={{marginLeft: '5px'}}>
                                    <Tab label="Projekt" {...a11yProps(0)} sx={styles.TabBorderStyle}/>
                                    <Tab label="Eigene Projekte" {...a11yProps(1)} sx={styles.TabBorderStyle}/>
                                </Tabs>
                            </Box>
                            <TabPanel value={tabValue} index={0}>
                                <DataListView
                                    projectList={bimProjects}
                                    deleteProject={Project_Delete}
                                    handleDeactivateClick={handleDeactivateClick}
                                    addNew={addNew}
                                    handleClickOnRow={handleClickOnRow}
                                />
                            </TabPanel>
                            <TabPanel value={tabValue} index={1}>
                                <BimUserProjects theRealm={theRealm} />
                            </TabPanel>
                        </>
                    ) : (
                        <BimUserProjects theRealm={theRealm} />
                    )}
                </div>
                <BimProjectCreate
                    bimProjectData={BimProjectSelected}
                    reloadProjects={reloadProjects}
                    setBimProjectSelected={setBimProjectSelected}
                />
            </div>
        </div>
    );
}

function mapState({theRealm}) {
    return {
        theRealm: theRealm
    }
}

export default connect(
    mapState,
    null
)(BimProjects);
